import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 py-16 md:py-24" data-id="element-133" data-mp="c7afa9dqsein">
      <div className="pointer-events-none absolute -left-20 top-16 h-56 w-56 rounded-full border border-brand-primary/20" data-id="element-134" data-mp="85fdl3rwfz4c" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full border border-brand-primary/15" data-id="element-135" data-mp="m46o6g7jz2nq" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative z-10 mx-auto max-w-4xl text-center" data-id="element-136" data-mp="h5c7bjt5bo69">
        <span className="inline-flex items-center rounded-full border border-brand-primary/35 bg-brand-cream/10 px-4 py-1.5 text-xs font-bold tracking-[0.14em] text-brand-cream uppercase" data-id="element-137" data-mp="qwglihazz501">
          Mamá sin Caos · Lactancia y calma
        </span>
        <h2 className="mt-5 font-serif text-5xl leading-[1.05] text-brand-cream-light md:text-6xl" data-id="element-138" data-mp="2c56e4c4hyjn3">
          La próxima toma puede sentirse diferente.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-brand-cream/75 md:text-xl" data-id="element-139" data-mp="2h5u6b14gp6iw">
          Elegí un método claro para entender a tu bebé, cuidar tu cuerpo y vivir la lactancia con más confianza.
        </p>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-brand-primary/35 bg-brand-cream/10 p-6 text-left sm:p-8" data-id="element-140" data-mp="2v3iq05msm7md">
          <p className="text-sm font-bold tracking-[0.12em] text-brand-accent uppercase" data-id="element-141" data-mp="301tyabxfwa2h">Tu único pack</p>
          <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="34uddfdbrzd9e">
            <div data-id="element-143" data-mp="39rdh5hl5k3xc">
              <h3 className="text-2xl font-bold text-brand-cream-light" data-id="element-144" data-mp="39rvnx85fy0ji">🍼 S.O.S. Lactancia</h3>
              <p className="mt-1 text-brand-cream/70" data-id="element-145" data-mp="3et2vp77l2zq6">6 tomos + 6 bonos · Acceso digital inmediato</p>
            </div>
            <div className="sm:text-right" data-id="element-146" data-mp="3ir0lab59nnu3">
              <p className="text-brand-primary/75 line-through" data-id="element-147" data-mp="1jnts5vleu1yv">$89.000 ARS</p>
              <p className="font-serif text-3xl font-bold text-brand-accent" data-id="element-148" data-mp="1ep8sbxa2lkay">$19.990 ARS</p>
            </div>
          </div>
        </div>

        <CTAButton label="✨ QUIERO MI PACK S.O.S. LACTANCIA ✨" data-id="element-149" data-mp="1shovqz6vvkce" />

        <div className="mt-7 flex flex-wrap justify-center gap-x-7 gap-y-3 text-sm text-brand-cream/80" data-id="element-150" data-mp="1nq6x4hsc1vul">
          <span className="flex items-center gap-2" data-id="element-151" data-mp="22ekzyspr1kb5"><LockIcon size={16} className="text-brand-accent" data-id="element-152" data-mp="22d9soix3hufa" /> Pago 100% seguro</span>
          <span className="flex items-center gap-2" data-id="element-153" data-mp="1xeousq5bfmu0"><ShieldCheckIcon size={16} className="text-brand-accent" data-id="element-154" data-mp="1xi493qr60rud" /> Garantía 7 días</span>
          <span className="flex items-center gap-2" data-id="element-155" data-mp="2bdf02t2agstg"><CreditCardIcon size={16} className="text-brand-accent" data-id="element-156" data-mp="27dedgl51dbbb" /> Mercado Pago</span>
        </div>
      </motion.div>
    </section>;
}